import React, { useRef, useEffect, useState } from 'react';
import Picture from '../Shared/Picture';
import options from '../ShopifyButtonOptions';
import {storefrontAccessToken} from '../ShopifyButtonOptions';


const BuyUsPopup = ({ productPopup, productHidePopUp, Product }) => {

    const [isShopify, setIsShopify] = useState(false);

    const closeOnOutsideClick = (ref) => {
        useEffect(() => {
            const handleClickOutside = (e) => {
                if (ref.current && !ref.current.contains(e.target)) {
                    productHidePopUp(e, "product");
                }
            }
            document.addEventListener("click", handleClickOutside);
            return () => {
                document.removeEventListener("click", handleClickOutside);
            };
        }, [ref]);
    }

    const contentRef = useRef(null);

    closeOnOutsideClick(contentRef);

    const handleShopifyID = () => {
        const shopifyID = Product.BuyCAUId && Product.BuyCAUId.Value !=="" ? Product.BuyCAUId.Value : null;
        return shopifyID;
    }
    const handleShopifyComponentID = () => {
        const shopifyComponentID = Product.BuyCADivProductComponentId && Product.BuyCADivProductComponentId.Value !=="" ? Product.BuyCADivProductComponentId.Value : null;
        return shopifyComponentID;
    }

    const handleShopifyClick = () => {
        setIsShopify(!isShopify);
    };

    const handleShopifyButton = () => {
        if(window.ShopifyBuy) {
            const client = ShopifyBuy.buildClient({
                domain: 'wella-buy-button.myshopify.com',
                storefrontAccessToken,
            });
            ShopifyBuy.UI.onReady(client).then((ui) => {
                if(document.getElementById(`product-component-${handleShopifyComponentID()}`)){
                    ui.createComponent('product', {
                        id: `${handleShopifyID()}`,
                        node: document.getElementById(`product-component-${handleShopifyComponentID()}`),
                        moneyFormat: '%24%7B%7Bamount%7D%7D',
                        options: options
                    });
                }
            })
        }
    }

    useEffect(() => {
        handleShopifyButton()
    }, []);

    return (
        <div>
            <div id="prodPop"
                className={productPopup ? ("ProductPopup prodPopUS global-popin-wrapper buyNow active") : ("ProductPopup prodPopUS global-popin-wrapper buyNow")}>
                <div className="ProductPopup global-popin-scroller">
                    <div className="global-popin-centered">
                        <div className="clearfix">
                            <section className="overlay"></section>
                            <section className="content" ref={contentRef}>
                                <a href="#" onClick={(e) => productHidePopUp(e, "product")}>
                                    <span className="close" data-test="close-button">
                                        <img src="\i\x_delete_close_denied_cross-512.png"/>
                                    </span>
                                </a>
                                <div className="left">
                                    <Picture
                                        src={[
                                            {
                                                Url: Product.BigImage.Value + "--resize,342,342",
                                                WebpUrl: Product.BigImage.Value + "--resize,342,342--returnTypeFile,webp"
                                            },
                                            {
                                                Url: Product.BigImage.Value + "--resize,125,125",
                                                WebpUrl: Product.BigImage.Value + "--resize,125,125--returnTypeFile,webp"
                                            },
                                            {
                                                Url: Product.BigImage.Value + "--resize,250,250",
                                                WebpUrl: Product.BigImage.Value + "--resize,250,250--returnTypeFile,webp"
                                            }
                                        ]}
                                        alt={Product.BigImageAlt.Value}
                                        className="prodImage"
                                        mobileHeight={125}
                                    />
                                </div>
                                <div className="right">
                                    <div className="productContent">
                                        <div className="text">
                                            <h3>{Product.Title.Value}</h3>
                                            <p dangerouslySetInnerHTML={{"__html": Product.Description.Value}}/>
                                        </div>
                                    </div>
                                    <div className="buyOptions">
                                        <div>
                                            <p className="retail-type">for home use</p>
                                            <h3>{Product.BuyOnlineText.Value}</h3>
                                            <ul>
                                                {Product.BuyOnlineItems.map((item, index) =>
                                                    <li key={item.BuyOnlineItemUrl} data-test="buyonline-item">
                                                        <a href={item.BuyOnlineItemUrl.Value}
                                                        target="_blank">{item.BuyOnlineItemText.Value}</a>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                        {
                                            Product.BuyCAText.Value && Product.BuyCAText.Value !=null ?
                                            <div className={isShopify ? "shopifyButton open" : "shopifyButton"}>
                                                <h3>
                                                    {Product.BuyCAText.Value && Product.BuyCAText.Value !=null ? Product.BuyCAText.Value : null}
                                                </h3>
                                                <p onClick={() => handleShopifyClick()}>Shop Now</p>
                                                <div id={`product-component-${handleShopifyComponentID()}`} className="shopifyComponent"></div>
                                            </div> :
                                            <div className="shopifyButton"></div>
                                        }
                                        {Product.ProfessionalsBuyOnlineText.Value !== "" &&
                                            <div>
                                                <p className="retail-type">for professional use</p>
                                                <h3>{Product.ProfessionalsBuyOnlineText.Value}</h3>
                                                <ul>
                                                 {Product.ProfessionalsBuyOnlineItems.map((item, index) =>
                                                    <li key={index}>
                                                        <a href={item.BuyOnlineItemUrl.Value}
                                                        target="_blank">{item.BuyOnlineItemText.Value}</a>
                                                    </li>
                                                 )}
                                                </ul>
                                            </div>
                                        }
                                        {Product.BuyInternationalText.Value !== "" &&
                                            <div>
                                                <h3 className="buyInternational">{Product.BuyInternationalText.Value}</h3>
                                                <ul>
                                                    <li>
                                                        <a href={Product.BuyInternationalUrl.Value}
                                                    target="_blank">wellastore.com</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        }
                                    </div>
                                    <div className="salon-finder">
                                        <a href={Product.SalonFinderUrl.Value}
                                           className="link">{Product.SalonFinderTextForLink.Value}</a>
                                        <h3 dangerouslySetInnerHTML={{__html: Product.SalonFinderText.Value}}/>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BuyUsPopup;
